import React from "react";
import "./SzAboutUs.css";
import { Tabs, Collapse } from "antd";
import { StickyContainer, Sticky } from "react-sticky";
import { FormattedMessage } from "react-intl";
import actions from "../../store/actions";
import { connect } from "react-redux";
import { GetTypeData, GetFAQList, GetFAQListByType } from "../../api/api";

const TabPane = Tabs.TabPane;
const Panel = Collapse.Panel;
let img1 = require("../../static/images/service.jpg");
let store = require("../../static/images/store.jpg");
let parking = require("../../static/images/parking.jpg");

const renderTabBar = (props, DefaultTabBar) => (
  <Sticky bottomOffset={80}>
    {({ style }) => (
      <DefaultTabBar
        {...props}
        style={{ ...style, zIndex: 1, background: "#fff" }}
      />
    )}
  </Sticky>
);

class AboutUs extends React.Component {
  state = {
    theme: "light",
    current: "1",
    List: [],
    TypeData: [],
    ListByType: [],
    Value: "",
  };
  typeChange = (Value) => {
    // if (Value == 0) {
    //     Value = "153"
    // } else if (Value == 1) {
    //     Value = "154"
    // } else if (Value == 2) {
    //     Value = "155"
    // } else {
    //     Value = "156"
    // }
    console.log(Value);
    /*获取FAQ的类型数据*/
    GetFAQListByType(Value, "SZ").then((response) => {
      let data = response.DataResult;
      if (data) {
        this.setState({
          ListByType: data,
        });
      }
    });
  };

  componentWillMount() {
    // GetFAQList().then((response) => {
    //     let data = response.DataResult;
    //     console.log(data);
    //     this.setState({
    //         List: data
    //     });
    // }).catch((error) => {
    //     //console.log(error);
    // });
    /*获取FAQ类型*/
    GetTypeData()
      .then((response) => {
        let data = response.DataResult;
        //console.log(data);
        if (data) {
          this.setState({
            TypeData: data,
          });
          let Value = data[0].value;
          console.log(data, "data----");
          GetFAQListByType(Value, "SZ").then((response) => {
            let data = response.DataResult;
            this.setState({
              ListByType: data,
            });
          });
        }
      })
      .catch((error) => {
        //console.log(error);
      });
    //let Value = 154;
  }

  render() {
    const enTabsObj = {
      "参观导览": "Guidance",
      "服务设施": "Facilities",
      "其他": "Others",
  }
    return (
      <div className="hallDiv">
        {/*标题*/}
        <div className="szaboutDiv aboutTitle">
          <div className="titleH4">
            <h4>
              <FormattedMessage id="intl-AboutUS-ABOUTSUS " />
            </h4>
            <p>
              <FormattedMessage id="intl-shAboutUS-title1" />
              <br />
              <FormattedMessage id="intl-shAboutUS-title2" />
            </p>
          </div>
        </div>
        {/*FAQ页面*/}
        <div className="szaboutDiv" onClick={this.GetFAQList}>
          <div className="aboutLeft">
            <Tabs
              tabPosition="left"
              style={{ textAlign: "left" }}
              className="sz-about-tab"
            >
              {/*参观时间*/}
              <TabPane
                tab={<FormattedMessage id="intl-AboutUS-Admissions" />}
                key="1"
              >
                <div className="aboutRight aboutUs">
                  {/* <h4>
                                    <i className="iconfont  icon-biao"> </i>
                                 <FormattedMessage
                                            id="intl-AboutUS-operationGuide"
                                        /> 
                                </h4> */}
                  <dl>
                    <dt>
                      <FormattedMessage id="intl-AboutUS-Hours" />
                    </dt>
                    <dd>
                      <p>
                        <FormattedMessage id="intl-shAboutUS-TheTimeThat" />
                      </p>
                    </dd>
                  </dl>

                  <dl>
                    <dt>
                      <FormattedMessage id="intl-shAboutUS-Closed" />
                    </dt>
                    <dd>
                      <p>
                        <FormattedMessage id="intl-shAboutUS-ClosedTime" />
                      </p>
                      <p>
                        <FormattedMessage id="intl-AboutUS-ClosedTime1" />
                      </p>
                    </dd>
                  </dl>
                </div>
              </TabPane>
              {/*参观指南*/}
              <TabPane
                tab={<FormattedMessage id="intl-AboutUS-Introduction" />}
                key="2"
              >
                <div className="aboutRight aboutUs">
                  <dl>
                    <dt>
                      <FormattedMessage id="intl-aboutus-reservations" />
                    </dt>
                    <dd>
                      <ul>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide1" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide2" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide3" />
                        </li>
                      </ul>
                    </dd>
                  </dl>
                  <dl>
                    <dt>
                      <FormattedMessage id="intl-aboutus-notes" />
                    </dt>
                    <dd>
                      <ul>
                        <li>
                          <FormattedMessage id="intl-szAboutUS-VisitorsGuide4" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide4-0" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide4-1" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide4-2" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide5" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide6" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide7" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide9" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide10" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-AboutUS-VisitorsGuide11" />
                        </li>
                      </ul>
                    </dd>
                  </dl>
                  <dl>
                    <dt>
                      <FormattedMessage id="intl-shAbountUS-jindai" />
                    </dt>
                    <dd>
                      <ul>
                        <li>
                          <FormattedMessage id="intl-shAbountUS-jindai1" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-shAbountUS-jindai2" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-shAbountUS-jindai3" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-shAbountUS-jindai4" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-shAbountUS-jindai5" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-shAbountUS-jindai6" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-shAbountUS-jindai7" />
                        </li>
                        <li>
                          <FormattedMessage id="intl-shAbountUS-jindai8" />
                        </li>
                      </ul>
                    </dd>
                  </dl>
                </div>
              </TabPane>

              {/*设施服务*/}
              <TabPane
                tab={<FormattedMessage id="intl-AboutUS-Facilities" />}
                key="3"
              >
                <div className="aboutRight aboutUs">
                  <table className="Facilities_table">
                    <tr>
                      <td className="shFacilities_left">
                        <div>
                          {/* <img src={parking} alt="" /> */}
                          <h3>
                            <FormattedMessage id="intl-szAboutUS-Facilities1" />
                          </h3>
                          <p>
                            <FormattedMessage id="intl-szAboutUS-Facilities2" />
                          </p>
                          <p>
                            <FormattedMessage id="intl-szAboutUS-Facilities3" />
                          </p>
                          <p>
                            <FormattedMessage id="intl-szAboutUS-Facilities4" />
                          </p>
                        </div>
                      </td>
                      <td className="shFacilities_right">
                        <div></div>
                      </td>
                    </tr>
                    <tr>
                      <td className="shFacilities_left">
                        <div>
                          <h3>
                            <FormattedMessage id="intl-szAboutUS-Facilities5" />
                          </h3>
                          <p>
                            <FormattedMessage id="intl-szAboutUS-Facilities6" />
                          </p>
                          <p>
                            <FormattedMessage id="intl-szAboutUS-Facilities7" />
                          </p>
                          {/* <p><FormattedMessage id="intl-szAboutUS-Facilities8" /></p> */}
                        </div>
                      </td>
                      <td className="shFacilities_right">
                        <div>{/* <img src={img1} alt="" /> */}</div>
                      </td>
                    </tr>

                    <tr>
                      <td className="shFacilities_left">
                        <div>
                          {/* <img src={store} alt="" /> */}
                          <h3>
                            <FormattedMessage id="intl-szAboutUS-Facilities9" />
                          </h3>
                          <p>
                            <FormattedMessage id="intl-szAboutUS-Facilities10" />
                          </p>
                          <p>
                            <FormattedMessage id="intl-szAboutUS-Facilities11" />
                          </p>
                          <p>
                            <FormattedMessage id="intl-szAboutUS-Facilities12" />
                          </p>
                          <p>
                            <FormattedMessage id="intl-szAboutUS-Facilities13" />
                          </p>
                        </div>
                      </td>
                      <td className="shFacilities_right">
                        <div></div>
                      </td>
                    </tr>
                  </table>
                </div>
              </TabPane>
              {/*导航路线*/}
              <TabPane
                tab={<FormattedMessage id="intl-AboutUS-Directions" />}
                key="4"
              >
                <div className="aboutRight">
                  <div className="layui-tab">
                    <div style={{ marginBottom: "20px" }}>
                      <h2>
                        <FormattedMessage id="intl-Home-shAboutUs" />
                      </h2>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                      <span>
                        <FormattedMessage id="intl-AboutUS-site" />
                      </span>
                      <span>
                        <FormattedMessage id="intl-szAboutUS-site1" />
                      </span>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                      <span>
                        <FormattedMessage id="intl-szAboutUS-ditieTitle" />
                      </span>
                      <span>
                        <FormattedMessage id="intl-szAboutUS-ditie1" />
                      </span>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                      <span style={{ visibility: "hidden" }}>
                        <FormattedMessage id="intl-szAboutUS-ditieTitle" />
                      </span>
                      <span>
                        <FormattedMessage id="intl-szAboutUS-ditie2" />
                      </span>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                      <span>
                        <FormattedMessage id="intl-szAboutUS-jiacheTitle" />
                      </span>
                      {/* <span><FormattedMessage id="intl-szAboutUS-jiache" /></span> */}
                    </div>
                    {/* <div style={{ marginBottom: "40px" }}>
                                        <FormattedMessage id="intl-aboutus-click"
                                            values={{
                                                here: <a target='_bank' href='https://www.amap.com/place/B0H3SHJ0OR'><FormattedMessage id='intl-aboutus-here' /></a>
                                            }}
                                        />

                                    </div> */}
                    <img src="images/sz/map.jpg" width="100%" />
                  </div>
                </div>
              </TabPane>
              {/*疑问介绍*/}
              <TabPane tab={<FormattedMessage id="intl-AboutUS-FAQ" />} key="5">
                <div className="aboutRight">
                  <div className="layui-tab">
                    <StickyContainer>
                      <Tabs
                        renderTabBar={renderTabBar}
                        onChange={this.typeChange}
                      >
                        {this.state.TypeData.map((item, index) => {
                          return (
                            <TabPane
                              tab={this.props.local === "en" ? enTabsObj[item.valueNameCN] : item.valueNameCN}
                              key={item.value}
                              //   style={{ height: 500 }}
                              value={item.value}
                            >
                              <Collapse bordered={false} showArrow={false}>
                                {this.state.ListByType
                                  ? this.state.ListByType.map((item, i) => {
                                      return (
                                        <Panel
                                          header={`Q : ${
                                            this.props.local === "en"
                                              ? item.englishTitle
                                              : item.chineseTitle
                                          }`}
                                          key={i}
                                          style={{ color: "red !important" }}
                                        >
                                          <span
                                            style={{
                                              color: "#007aff",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            A :{" "}
                                          </span>
                                          {this.props.local === "en" ? (
                                            <p
                                              dangerouslySetInnerHTML={{
                                                __html: item.englishContent,
                                              }}
                                              style={{
                                                display: "inline-block",
                                              }}
                                            ></p>
                                          ) : (
                                            <p
                                              dangerouslySetInnerHTML={{
                                                __html: item.chineseContent,
                                              }}
                                              style={{
                                                display: "inline-block",
                                              }}
                                            ></p>
                                          )}
                                        </Panel>
                                      );
                                    })
                                  : []}
                              </Collapse>
                            </TabPane>
                          );
                        })}
                      </Tabs>
                    </StickyContainer>
                  </div>
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({ ...state.Language }),
  actions.Language
)(AboutUs);



// WEBPACK FOOTER //
// ./src/containers/SzAboutUs/SzAboutUs.js